// extracted by mini-css-extract-plugin
export default {"gpa__default_footer_section_wrapper":"DefaultFooter_gpa__default_footer_section_wrapper__PW5VM","gpa__dark_mode":"DefaultFooter_gpa__dark_mode__zV9fg"};